import React from 'react';
import * as navigate from 'app/area/shared/navigation';
import { MeatballMenu, ButtonCallToAction, ButtonTertiary, PromptConfirmationModal } from 'ui';
import { Tag } from 'app/components/tag';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { StickyHeader, StickyHeaderButtonContainer } from 'app/shell/components/sticky-header/sticky-header';
import { ExperienceTransferActionType, ExperienceTransferStickyHeaderProps } from '../types';
import { replaceTemplateString } from 'app/infrastructure/platform';
import { routeConstants } from 'app/routes/route-constants';
import { isDisabled } from 'app/infrastructure/data/date';
import styles from './experience-transfer-sticky-header.scss';

export const ExperienceTransferStickyHeader: React.FC<ExperienceTransferStickyHeaderProps> = ({
  actionType, shouldPrompt, experienceTransferItem, name, fetching, translation, onSave, onDelete
}) => {

  const updatingItem = isDefinedIncludingZero(experienceTransferItem?.id);
  const onCancel = () => {
    navigate.to({ pathname: routeConstants.experienceTransferList });
  };

  return <StickyHeader className={styles.header}
    rightSideContent={<>
      <StickyHeaderButtonContainer>
        <ButtonTertiary
          id="experience-transfer-form-sticky-header-cancel-button"
          onClick={onCancel}>
          {translation.cancel}
        </ButtonTertiary>
        <ButtonCallToAction
          id="experience-transfer-form-sticky-header-save-button"
          onClick={onSave}
          disabled={!shouldPrompt}>
          {translation.save}
        </ButtonCallToAction>
      </StickyHeaderButtonContainer>
      {actionType === ExperienceTransferActionType.edit && experienceTransferItem.id !== 0
        ? <MeatballMenu className={styles.meatball} id="experience-transfer-form-sticky-header-meatballmenu">
          <li>
            <PromptConfirmationModal
              title={translation.delete_experience_transfer}
              description={replaceTemplateString(
                translation.delete_confirmation,
                experienceTransferItem?.id,
                name)}
              continueText={translation.delete}
              cancelText={translation.cancel}
              onContinue={onDelete}>
              <button type="button" className="dropdown-item" disabled={fetching}>
                {translation.delete}
              </button>
            </PromptConfirmationModal>
          </li>
        </MeatballMenu> : null}
    </>}>
    <div className={styles.headerTitle}>
      {translation.experience_transfer}
    </div>
    <div className={styles.headerContainer}>
      <h2 className={styles.headerSubtitle}>
        {!updatingItem ? translation.new_experience_transfer : null}
      </h2>
      {updatingItem ? <span className={styles.headerId}>
        #{experienceTransferItem.id}
      </span> : null}
      {(!experienceTransferItem.active || isDisabled(experienceTransferItem.subscriberGroup?.disabled))
        && <Tag>{translation.inactive}</Tag>}
    </div>
  </StickyHeader>;
};
